/** BR-11 — `Paused · Jan 14, 2026, 3:45 PM` / `Stopped · …` on launch rows. */

export function formatInstrumentLifecycleTimestamp(iso: string | null | undefined): string {

  if (!iso) return ''

  const date = new Date(iso)

  if (Number.isNaN(date.getTime())) return ''

  return new Intl.DateTimeFormat('en-US', {

    month: 'short',

    day: 'numeric',

    year: 'numeric',

    hour: 'numeric',

    minute: '2-digit',

  }).format(date)

}



export function launchStatusLabelWithTimestamp(

  baseLabel: string,

  iso: string | null | undefined,

): string {

  const ts = formatInstrumentLifecycleTimestamp(iso)

  return ts ? `${baseLabel} · ${ts}` : baseLabel

}

